import { Component, HostBinding, ViewChild } from '@angular/core';
import { SettingsNavigationContentComponent } from '../../../../models/settings-navigation-content-component';
import { Endpoint, SettingsType } from '../../../../models/enums';
import { GenericTreeNode } from '../../../generic-tree/generic-tree-node';
import { CommonService } from '../../../../services/common/common.service';
import { RestService } from '../../../../services/rest/rest.service';
import { ActionType, ObjectActionListType, Permissions } from '../../../../models/permission';
import { DrNamedQuery } from '../../../../models/dr-named-query';
import { KeyValueListComponent } from '../../../key-value-list/key-value-list.component';

@Component({
    standalone: false,
    selector: 'res-tls-express-email-lists',
    templateUrl: './tls-express-email-lists.component.html',
    styleUrls: ['./tls-express-email-lists.component.scss']
})
export class TlsExpressEmailListsComponent implements SettingsNavigationContentComponent {
    @HostBinding('class') classes = 'maximized-component';
    @ViewChild(KeyValueListComponent, { static: true }) keyValueEmailList: KeyValueListComponent;

    validChanges = true;
    hasAddEditPermission: boolean;
    isBusy = false;
    isBusyMessage = 'Loading ...';
    emailAddresses = [];
    permissionType: ObjectActionListType;

    constructor(private commonService: CommonService,
        private restService: RestService) {
    }

    get isDirty(): boolean {
        if (this.keyValueEmailList) {
            return this.keyValueEmailList.keyValueForm?.form?.dirty;
        }
        return false;
    }

    saveChanges(autoSaveChanges?: boolean): Promise<boolean> {
        return new Promise<boolean>((resolve) => {
            if (this.commonService.currentOrganizationHandle) {
                this.isBusy = true;
                this.isBusyMessage = 'Saving Email Lists...';
                const requestData = { organizationName: this.commonService.currentOrganizationHandle };
                const recipients = DrNamedQuery.removeEmptyNames(this.emailAddresses).map(r => r.name);
                Object.assign(requestData, this.permissionType === ObjectActionListType.TLS_PM_EMAIL_RECIPIENTS ? { pmEmailRecipients: recipients } : { salesEmailRecipients: recipients });
                this.restService.post(Endpoint.orgManager_setReefExpressSettings, requestData).then(() => {
                    this.isBusy = false;
                    this.keyValueEmailList?.keyValueForm?.form?.markAsPristine();
                    resolve(true);
                }, () => {
                    resolve(false);
                    this.isBusy = false;
                });
            } else {
                resolve(false);
            }
        });
    }

    discardChanges(): void {
        this.emailAddresses = [new DrNamedQuery({ name: '' })];
        this.loadData();
        this.keyValueEmailList?.keyValueForm?.form?.markAsPristine();
    }

    isDisabled(): boolean {
        let isDisabled = true;
        if (!this.isBusy && this.isDirty) {
            isDisabled = false;
        }
        return isDisabled;
    }

    selectedTreeItemChanged(node: GenericTreeNode, projectHandle?: string, settingsType?: SettingsType): void {
        this.permissionType = node?.name === 'PM Email Lists' ? ObjectActionListType.TLS_PM_EMAIL_RECIPIENTS : ObjectActionListType.TLS_SALES_EMAIL_RECIPIENTS;
        this.hasAddEditPermission = Permissions.checkUserPermission(this.permissionType, ActionType.CREATE);
        this.emailAddresses.push(new DrNamedQuery({ name: '' }));
        this.loadData();
    }

    loadData(): void {
        if (this.commonService.currentOrganizationHandle) {
            this.isBusy = true;
            this.restService.post(Endpoint.orgManager_getReefExpressSettings, { handle: this.commonService.currentOrganizationHandle }).then((response) => {
                let emailList = null;
                if (response?.pmEmailreceipients && this.permissionType === ObjectActionListType.TLS_PM_EMAIL_RECIPIENTS) {
                    emailList = response.pmEmailreceipients;
                }
                if (response?.salesEmailreceipients && this.permissionType === ObjectActionListType.TLS_SALES_EMAIL_RECIPIENTS) {
                    emailList = response.salesEmailreceipients;
                }
                if (emailList?.length > 0) {
                    emailList.forEach((el: string) => this.emailAddresses.unshift(new DrNamedQuery({ name: el })));
                }
                this.emailAddresses = [].concat(this.emailAddresses);
                this.isBusy = false;
            }, () => { this.isBusy = false; });
        }
    }

    // openHelp = () => this.commonService.openHelp(HelpIndex.admin_manage_settings_dlg); //TODO LIANA
}
